import clsx from 'clsx';
import * as React from 'react';
import FormCheck from './FormCheck.js';
import FormControl from './FormControl.js';
import FormFloating from './FormFloating.js';
import FormGroup from './FormGroup.js';
import FormLabel from './FormLabel.js';
import FormRange from './FormRange.js';
import FormSelect from './FormSelect.js';
import FormText from './FormText.js';
import Switch from './Switch.js';
import FloatingLabel from './FloatingLabel.js';
import { jsx as _jsx } from "react/jsx-runtime";
const Form = /*#__PURE__*/React.forwardRef(({
  className,
  validated,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'form',
  ...props
}, ref) => /*#__PURE__*/_jsx(Component, {
  ...props,
  ref: ref,
  className: clsx(className, validated && 'was-validated')
}));
Form.displayName = 'Form';
export default Object.assign(Form, {
  Group: FormGroup,
  Control: FormControl,
  Floating: FormFloating,
  Check: FormCheck,
  Switch,
  Label: FormLabel,
  Text: FormText,
  Range: FormRange,
  Select: FormSelect,
  FloatingLabel
});